import { render, staticRenderFns } from "./TemplateTwo.vue?vue&type=template&id=aa323962&scoped=true&"
import script from "./TemplateTwo.vue?vue&type=script&lang=js&"
export * from "./TemplateTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa323962",
  null
  
)

export default component.exports